import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const handoverPlugin = createPlugin({
  id: 'handover',
  routes: {
    root: rootRouteRef,
  },
});

export const HandoverPage = handoverPlugin.provide(
  createRoutableExtension({
    name: 'HandoverPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);

export const EntitySystemHandoverContent = handoverPlugin.provide(
  createRoutableExtension({
    name: 'EntitySystemHandoverContent',
    component: () =>
      import('./components/HandoverPage').then(m => m.HandoverPage),
    mountPoint: rootRouteRef,
  }),
);
